import { Modal as SharedModal, ModalProps } from '@resal-frontend/ui/index';
import { useAlertState } from '@resal-frontend/ui/index';

export const Modal = (props: Omit<ModalProps, 'dim'>) => {
  const dim = useAlertState().length > 0;
  return <SharedModal {...props} dim={dim} />;
};
